<app-modal
  [title]="'Modifier la connection string « ' + data.nomConnectionString + ' »'"
  size="md"
  closeLabel="Fermer"
  (closed)="annuler()"
>
  @if (data.connexionAnnuaire) {
    <div class="reprise_annuaire">
      <button
        type="button"
        appButton
        variant="outline"
        icon="refresh"
        appTooltip="Pré-remplit le formulaire avec les valeurs de connexion de l'annuaire legacy"
        (click)="reprendreAnnuaire()"
      >
        Reprendre les valeurs de l'annuaire
      </button>
    </div>
  }

  <form [formGroup]="baseDeDonneesForm" class="formulaire_base_de_donnees">
    <app-form-field label="Serveur" [required]="true">
      <app-input formControlName="serveur" [maxLength]="longueurs.serveur" />
    </app-form-field>

    <app-form-field label="Base de données" [required]="true">
      <app-input formControlName="baseDeDonnees" [maxLength]="longueurs.nomBaseDeDonnees" />
    </app-form-field>

    <app-form-field label="Utilisateur">
      <app-input formControlName="utilisateur" [maxLength]="longueurs.utilisateur" />
    </app-form-field>

    <app-form-field label="Mot de passe">
      <app-input
        type="password"
        revealable
        autocomplete="new-password"
        formControlName="motDePasse"
        [maxLength]="longueurs.secret"
      />
      @if (motDePasseDepuisAnnuaire()) {
        <span appFieldHint>Le mot de passe de l'annuaire sera repris (saisir une valeur pour le remplacer)</span>
      } @else {
        <span appFieldHint>Laisser vide pour conserver le mot de passe actuel</span>
      }
    </app-form-field>
  </form>

  <div appModalFooter>
    <button type="button" appButton variant="ghost" (click)="annuler()">Annuler</button>
    <button type="button" appButton variant="primary" [disabled]="!peutValider()" (click)="valider()">Valider</button>
  </div>
</app-modal>
